import * as typography from "../typography";
import * as colors from "./colors";

export const theme = {
  ...colors,
  typography,
} as const;
